import ProvisioningFormPolicyContainer from './ProvisioningFormPolicyContainer';

export default ProvisioningFormPolicyContainer;
